module.exports = __webpack_public_path__ + "img/ico_landing-share.5670cfeb.svg";